import { render, staticRenderFns } from "./reuse-tab.vue?vue&type=template&id=66e792f2&scoped=true"
import script from "./reuse-tab.vue?vue&type=script&lang=js"
export * from "./reuse-tab.vue?vue&type=script&lang=js"
import style0 from "./reuse-tab.vue?vue&type=style&index=0&id=66e792f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e792f2",
  null
  
)

export default component.exports